import React from "react";
import Links from "@mui/material/Link";
import LoginHeader from "./components/LoginHeader.js";
import SideNavigation from "./components/SideNavigation.js";
import Breadcrumbs from "@mui/material/Breadcrumbs";
import { useRef, useEffect, useState } from "react";
import Button from "@mui/material/Button";
import { geocodeByAddress, getLatLng } from "react-places-autocomplete";
import Swal from "sweetalert2";
import CircularProgress from "@mui/material/CircularProgress";
import Backdrop from "@mui/material/Backdrop";
import Typography from "@mui/material/Typography";
import { Link } from "react-router-dom";
import NavigateNextIcon from "@mui/icons-material/NavigateNext";
import { Dropdown } from "primereact/dropdown";
import "./table.css";
import AADHeader from "./components/AADHeader.js";

export default function Home() {
  const username = localStorage.getItem("userName");
  const [isSidebarOpen, setIsSidebarOpen] = useState(window.innerWidth >= 768);
  const [loading, setLoading] = React.useState(false);
  const [countries, setCountries] = useState();
  const [sitename, setName] = useState("");
  const [nameError, setNameError] = useState("");
  const [address1, setAddress1] = useState("");
  const [country, setCountry] = useState("");
  const [city, setCity] = useState("");
  const [state, setState] = useState("");
  const [postalcode, setPostalCode] = useState("");
  const [lat, setLatitude] = useState("");
  const [lng, setLongitude] = useState("");
  const [message, setMessage] = useState("");
  const [sitetype, setSiteType] = useState("");
  const [getsitetype, setGetSiteType] = useState([]);
  const [mapLoaded, setMapLoaded] = useState(false);
  const [query, setQuery] = useState("");
  const autoCompleteRef = useRef(null);
  const [inputList, setInputList] = useState([{ businessunit: "", businessunitvalue: "" }]);
  const [bunit, setBunit] = useState([{ bunit: "", bunitvalue: "" }]);
  const [businessunit, setBusinessUnit] = useState();
  const [businessunit1, setBusinessUnit1] = useState();
  // const fixedHeightPaper = clsx(classes.paper, classes.fixedHeight);
  const [isButtonDisabled, setIsButtonDisabled] = useState(false);
  const [isButtonDisabled1, setIsButtonDisabled1] = useState(false);
  const [legalEntityAllocationExceeds100, setLegalEntityAllocationExceeds100] = useState(false);
  const [businessUnitAllocationExceeds100, setBusinessUnitAllocationExceeds100] = useState(false);
  const [activebu, setActiveBU] = useState("");
  const [activele, setActiveLE] = useState("");

  const toggleSidebar = () => {
    setIsSidebarOpen((prev) => !prev);
  };

  useEffect(() => {
    const handleResize = () => {
      if (window.innerWidth < 768) {
        setIsSidebarOpen(false); // Close sidebar on mobile
      } else {
        setIsSidebarOpen(true); // Open sidebar on larger screens
      }
    };

    window.addEventListener("resize", handleResize);

    return () => {
      window.removeEventListener("resize", handleResize);
    };
  }, []);

  let autoComplete;

  const loadScript = (url, callback) => {
    let script = document.createElement("script");
    script.type = "text/javascript";

    if (script.readyState) {
      script.onreadystatechange = function () {
        if (script.readyState === "loaded" || script.readyState === "complete") {
          script.onreadystatechange = null;
          callback();
        }
      };
    } else {
      script.onload = () => callback();
    }

    script.src = url;
    document.getElementsByTagName("head")[0].appendChild(script);
  };

  function handleScriptLoad(updateQuery, autoCompleteRef) {
    autoComplete = new window.google.maps.places.Autocomplete(autoCompleteRef.current);
    autoComplete.setFields(["address_components", "formatted_address"]);
    autoComplete.addListener("place_changed", () => handlePlaceSelect(updateQuery));
  }

  async function handlePlaceSelect(updateQuery) {
    const addressObject = autoComplete.getPlace();
    const query = addressObject.formatted_address;
    updateQuery(query);
    setAddress1(query);
    const results = await geocodeByAddress(query);
    const { lat, lng } = await getLatLng(results[0]);
    setLatitude(lat.toFixed(4));
    setLongitude(lng.toFixed(4));
    let cityValue = "";
    let pincodeValue = "";
    let countryValue = "";
    let countryShortName = "";
    let stateValue = "";

    results[0].address_components.forEach((component) => {
      console.log(component);
      if (component.types.includes("locality")) {
        cityValue = component.long_name;
      }
      if (component.types.includes("country")) {
        countryValue = component.long_name;
        console.log("countryValue",countryValue);
        countryShortName = component.short_name;
      }
      if (component.types.includes("administrative_area_level_1")) {
        stateValue = component.long_name;
      }
      if (component.types.includes("postal_code")) {
        pincodeValue = component.long_name;
      }
    });

    setCity(cityValue);
    const pincodeValueWithoutSpaces = pincodeValue.replace(/\s+/g, '');
    setPostalCode(pincodeValueWithoutSpaces);
    setState(stateValue);
    
    // Debug: Check what country values we have
    console.log("Country Long Name:", countryValue);
    console.log("countryValue", countryValue);
    console.log("Country Short Name:", countryShortName);
    console.log("Available countries from API:", countries);
    
    // Set country - try to match with API list, otherwise use long_name
    if (countries && Array.isArray(countries)) {
      // Check if long_name exists in countries list
      if (countries.includes(countryValue)) {
        setCountry(countryValue);
        console.log("✓ Setting country using long name:", countryValue);
      } 
      // Check if short_name exists in countries list
      else if (countries.includes(countryShortName)) {
        setCountry(countryShortName);
        console.log("✓ Setting country using short name:", countryShortName);
      } 
      // Use long_name even if not in list (will show in dropdown)
      else {
        setCountry(countryValue);
        console.log("⚠ Country not in API list, setting long name anyway:", countryValue);
        console.log("Available countries:", countries);
      }
    } else {
      // If countries not loaded yet, still set the value
      setCountry(countryValue);
      console.log("⚠ Countries list not loaded, setting country:", countryValue);
    }
    
    console.log("Address object:", addressObject);
  }

  async function fetchData() {
    try {
      const response = await fetch(`${process.env.REACT_APP_BASE_API_URL}countries`);
      const data = await response.json();
      console.log("Countries API Response:", data);
      setCountries(data);
    } catch (error) {
      console.error("Error fetching countries:", error);
    }
  }
  useEffect(() => {
    fetchData();
    loadScript(
      `https://maps.googleapis.com/maps/api/js?key=AIzaSyD5Yfe8E1kXXtdJ36h-XDoed0l3TagQFgM&libraries=places`,
      () => handleScriptLoad(setQuery, autoCompleteRef)
    );
  }, []);

  var myHeaders = new Headers();
  myHeaders.append("username", username);

  var requestOptions = {
    method: "GET",
    headers: myHeaders,
    redirect: "follow",
  };
  async function fetchLegalEntity() {
    try {
      const response = await fetch(
        `${process.env.REACT_APP_BASE_API_URL}list-entities`,
        requestOptions
      );
      if (response.status === 200) {
        const responseJson = await response.json();
        if (responseJson.success == false) {
          setBusinessUnit("");
        } else if (responseJson.status == 400) {
          setBusinessUnit("");
        } else {
          setBusinessUnit(responseJson);
          setActiveLE(responseJson.data.filter((item) => item.isActive === true));
        }
      } else {
        setBusinessUnit("");
      }
    } catch (error) {
      console.error(error);
    }
  }
  async function fetchBusinessUnit() {
    try {
      const response = await fetch(
        `${process.env.REACT_APP_BASE_API_URL}list-businessunits`,
        requestOptions
      );
      if (response.status === 200) {
        const responseJson = await response.json();
        if (responseJson.success == false) {
          setBusinessUnit1("");
        } else if (responseJson.status == 400) {
          setBusinessUnit1("");
        } else {
          setBusinessUnit1(responseJson);
          setActiveBU(responseJson.data.filter((item) => item.isActive === true));
        }
      } else {
        setBusinessUnit1("");
      }
    } catch (error) {
      console.error(error);
    }
  }

  async function fetchSiteType() {
    try {
      const response = await fetch(
        `${process.env.REACT_APP_BASE_API_URL}list-sitetype`,
        requestOptions
      );
      if (response.status === 200) {
        const responseJson = await response.json();
        if (responseJson.success == false) {
          setGetSiteType([]);
        } else if (responseJson.status == 400) {
          setGetSiteType([]);
        } else {
          const types = Array.isArray(responseJson)
            ? responseJson
            : Array.isArray(responseJson?.data)
              ? responseJson.data
              : [];
          setGetSiteType(types);
        }
      } else {
        setGetSiteType([]);
      }
    } catch (error) {
      console.error(error);
    }
  }

  useEffect(() => {
    fetchBusinessUnit();
    fetchLegalEntity();
    fetchSiteType();
  }, []);

  // Allow only numeric input for percentage (max 2 decimal places, e.g. 50 or 33.5 or 33.55)
  // Note: This regex is permissive for typing (e.g. `50.` is allowed while user is still typing).
  const isNumericPercentage = (val) => val === "" || /^\d*\.?\d{0,2}$/.test(val);
  // Allow only 0–100% (reject values > 100)
  const isValidPercentageRange = (val) => {
    if (val === "") return true;
    const num = parseFloat(val);
    return !isNaN(num) && num >= 0 && num <= 100;
  };

  const sumAllocation = (rows, key) =>
    rows.reduce((acc, item) => acc + (parseFloat(item?.[key]) || 0), 0);

  const formatPct = (n) => {
    const num = Number.isFinite(n) ? n : 0;
    const rounded = Math.round((num + Number.EPSILON) * 100) / 100; // up to 2 decimals
    return `${rounded % 1 === 0 ? rounded.toFixed(0) : rounded.toFixed(2)}%`;
  };

  const legalEntityTotal = sumAllocation(inputList, "businessunitvalue");
  const businessUnitTotal = sumAllocation(bunit, "bunitvalue");

  // Show allocation warnings only after user starts entering % values
  const hasAnyLegalAllocation = inputList.some(
    (item) => String(item?.businessunitvalue ?? "").trim() !== ""
  );
  const hasAnyBusinessUnitAllocation = bunit.some(
    (item) => String(item?.bunitvalue ?? "").trim() !== ""
  );

  const legalEntityAllocationBelow100 =
    hasAnyLegalAllocation && legalEntityTotal < 100 && legalEntityTotal >= 0;
  const businessUnitAllocationBelow100 =
    hasAnyBusinessUnitAllocation && businessUnitTotal < 100 && businessUnitTotal >= 0;

  // A row is incomplete when only one of the dropdown selection / % value has been filled in
  const hasIncompleteRow = (rows, selectKey, valueKey) =>
    rows.some((row) => {
      const hasSelect = String(row?.[selectKey] ?? "").trim() !== "";
      const hasValue = String(row?.[valueKey] ?? "").trim() !== "";
      return hasSelect !== hasValue;
    });

  const legalEntityMissingSelection = hasIncompleteRow(
    inputList,
    "businessunit",
    "businessunitvalue"
  );
  const businessUnitMissingSelection = hasIncompleteRow(bunit, "bunit", "bunitvalue");

  const AllocationBanner = ({ currentTotal, label, show }) => {
    if (!show) return null;
    const over = Math.max(0, currentTotal - 100);
    const under = Math.max(0, 100 - currentTotal);
    if (over <= 0 && under <= 0) return null;
    const isOver = over > 0;
    const panelColor = isOver ? "#FDECEC" : "#FFF7E6";
    const textColor = isOver ? "#8A1F1F" : "#8A5D1F";
    const badgeColor = isOver ? "#6B2B2B" : "#7A5A28";
    const titleText = isOver
      ? `Allocation is ${formatPct(over)} over the limit`
      : `Allocation is ${formatPct(under)} below the target`;
    const descriptionText = isOver
      ? `Your ${label} split currently adds up to ${formatPct(
          currentTotal
        )}. Update one or more values so the total equals 100% before continuing.`
      : `Your ${label} split currently adds up to ${formatPct(
          currentTotal
        )}. Add or adjust values so the total reaches 100% before continuing.`;
    return (
      <div
        style={{
          marginTop: "12px",
          background: panelColor,
          borderRadius: "10px",
          padding: "14px 16px",
          display: "flex",
          gap: "12px",
          alignItems: "flex-start",
          fontFamily: "Poppins",
          color: textColor,
          textAlign: "left",
          // Extend slightly to the right to visually match input width/gutter
          width: "calc(100% + 15px)",
          marginRight: "-15px",
          boxSizing: "border-box",
        }}
      >
        <div style={{ marginTop: "2px", flex: "0 0 auto" }}>
          <svg width="22" height="22" viewBox="0 0 24 24" fill="none" aria-hidden="true">
            <circle cx="12" cy="12" r="10" stroke={textColor} strokeWidth="2" />
            <path d="M12 7v6" stroke={textColor} strokeWidth="2" strokeLinecap="round" />
            <path d="M12 16.5h.01" stroke={textColor} strokeWidth="3" strokeLinecap="round" />
          </svg>
        </div>

        <div style={{ flex: "1 1 auto", textAlign: "left" }}>
          <div style={{ fontWeight: 600, fontSize: "16px", marginBottom: "6px", textAlign: "left" }}>
            {titleText}
          </div>
          <div style={{ fontSize: "14px", lineHeight: "20px", marginBottom: "10px", textAlign: "left" }}>
            {descriptionText}
          </div>

          <div style={{ display: "flex", gap: "10px", flexWrap: "wrap", justifyContent: "flex-start" }}>
            <span
              style={{
                background: "#FFFFFF",
                borderRadius: "999px",
                padding: "6px 12px",
                fontSize: "13px",
                color: badgeColor,
                textAlign: "left",
              }}
            >
              Current total: {formatPct(currentTotal)}
            </span>
            <span
              style={{
                background: "#FFFFFF",
                borderRadius: "999px",
                padding: "6px 12px",
                fontSize: "13px",
                color: badgeColor,
                textAlign: "left",
              }}
            >
              Target total: 100%
            </span>
            <span
              style={{
                background: "#FFFFFF",
                borderRadius: "999px",
                padding: "6px 12px",
                fontSize: "13px",
                color: badgeColor,
                textAlign: "left",
              }}
            >
              Review values above
            </span>
          </div>
        </div>
      </div>
    );
  };

  // handle input change
  const handleInputChange = (e, index) => {
    const { name, value } = e.target;
    if (name === "businessunitvalue") {
      if (!isNumericPercentage(value) || !isValidPercentageRange(value)) return;
      // Allow user to enter values that sum to more than 100%; we show error and disable submit instead
    }
    // Legal Entity
    const list = [...inputList];
    list[index][name] = value;
    setInputList(list);
    const sumList = sumAllocation(list, "businessunitvalue");
    // Show error and disable submit when total > 100%
    setLegalEntityAllocationExceeds100(sumList > 100);
    // Don't allow adding more rows when allocation is equal or more than 100%
    setIsButtonDisabled(sumList >= 100);
  };

  const handleInputChange1 = (e, index) => {
    const { name, value } = e.target;
    if (name === "bunitvalue") {
      if (!isNumericPercentage(value) || !isValidPercentageRange(value)) return;
      // Allow user to enter values that sum to more than 100%; we show error and disable submit instead
    }
    // Business Unit
    const list1 = [...bunit];
    list1[index][name] = value;
    setBunit(list1);
    const sumList1 = sumAllocation(list1, "bunitvalue");
    setBusinessUnitAllocationExceeds100(sumList1 > 100);
    // Don't allow adding more rows when allocation is equal or more than 100%
    setIsButtonDisabled1(sumList1 >= 100);
  };

  // handle click event of the Remove button
  const handleRemoveClick = (index) => {
    const list = [...inputList];
    list.splice(index, 1);
    setInputList(list);
    const sumList = sumAllocation(list, "businessunitvalue");
    setLegalEntityAllocationExceeds100(sumList > 100);
    setIsButtonDisabled(sumList >= 100);
  };

  // const handleRemoveClick1 = (index) => {
  //   // Business Unit
  //   const list1 = [...bunit];
  //   list1.splice(index, 1);
  //   setBunit(list1);
  //   var allocate11 = [];
  //   var result = list1.reduce(function (map, obj) {
  //     map[obj.bunit] = obj.bunitvalue;
  //     allocate11.push(obj.bunitvalue);
  //     return map;
  //   }, {});
  //   if (bunit.length === 0) {
  //     console.log("Zero Value");
  //   }
  //   const sumList1 = allocate11.reduce((accumulator, currentValue) => {
  //     return accumulator + parseInt(currentValue);
  //   }, 0);
  //   console.log(sumList1);
  //   if (sumList1 >= 100) {
  //     setIsButtonDisabled1(true);
  //   } else {
  //     setIsButtonDisabled1(false);
  //   }
  // };

  const handleRemoveClick1 = (index) => {
    const list1 = [...bunit];
    list1.splice(index, 1); // Remove the selected BU at the index
  
    // Check if the list becomes empty
    if (list1.length === 0) {
      setBunit([{ bunit: "", bunitvalue: "" }]); // Ensure at least one empty field remains
      setBusinessUnitAllocationExceeds100(false);
      setIsButtonDisabled1(false);
    } else {
      setBunit(list1); // Update the bunit state with the new list
      const sumList1 = sumAllocation(list1, "bunitvalue");
      setBusinessUnitAllocationExceeds100(sumList1 > 100);
      setIsButtonDisabled1(sumList1 >= 100);
    }
  };
  

  // handle click event of the Add button
  const handleAddClick = () => {
    const total = sumAllocation(inputList, "businessunitvalue");
    if (total >= 100) {
      Swal.fire({
        icon: "error",
        html: `<h4 style="color:#CC2229; font-size: 20px; font-weight: bold;">Error!</h4>
        <p style="font-size: 16px;font-family:Poppins;">Cannot add more legal entities because total allocation is already ${total}%. Please adjust the values.</p>`,
        iconHtml: '<img src="assets/img/error.png" style="width: 55px; height: 55px;" />',
      });
      return;
    }
    setInputList([...inputList, { businessunit: "", businessunitvalue: "" }]);
  };

  const handleAddClick1 = () => {
    const total = sumAllocation(bunit, "bunitvalue");
    if (total >= 100) {
      Swal.fire({
        icon: "error",
        html: `<h4 style="color:#CC2229; font-size: 20px; font-weight: bold;">Error!</h4>
        <p style="font-size: 16px;font-family:Poppins;">Cannot add more business units because total allocation is already ${total}%. Please adjust the values.</p>`,
        iconHtml: '<img src="assets/img/error.png" style="width: 55px; height: 55px;" />',
      });
      return;
    }
    setBunit([...bunit, { bunit: "", bunitvalue: "" }]);
  };

  let handleSubmit = async (e) => {
    setLoading(true);
    e.preventDefault();
    if (!/^[a-zA-Z0-9\-_\s]*$/.test(sitename)) {
      setNameError("Special characters are not allowed.");
      setLoading(false);
      return;
    }
    try {
      let rest = await fetch(`${process.env.REACT_APP_BASE_API_URL}check-sitelocation`, {
        method: "GET",
        headers: {
          "Content-type": "application/json; charset=UTF-8",
          username: username,
          name: sitename,
        },
      });
      if (postalcode === "") {
        setLoading(false);
        Swal.fire({
          icon: "error",
          html: `<h4 style="color: #CC2229; font-size: 20px; font-weight: bold;">Error!</h4>
                 <p style="font-size: 16px;">Postal code is required</p>`,
          iconHtml: '<img src="assets/img/error.png" style="width: 55px; height: 55px;" />',
        });
        return false;
      }

      if (!validatePostalCode(postalcode)) {
        setLoading(false);
        Swal.fire({
          icon: "error",
          html: `<h4 style="color: #CC2229; font-size: 20px; font-weight: bold;">Error!</h4>
                 <p style="font-size: 16px;">Please enter a valid postal code.</p>`,
          iconHtml: '<img src="assets/img/error.png" style="width: 55px; height: 55px;" />',
        });
        return false;
      }

      if (rest.status === 200) {
        const responseJson1 = await rest.json();
        if (responseJson1.data === true) {
          setLoading(false);
          Swal.fire({
            icon: "error",
            html: `<h4 style="color:#CC2229; font-size: 20px; font-weight: bold;">Error!</h4>
            <p style="font-size: 16px;">Site location already exist</p>`,
            iconHtml: '<img src="assets/img/error.png" style="width: 55px; height: 55px;" />',
          });
        } else if (responseJson1.status === 400) {
          setLoading(false);
          Swal.fire({
            icon: "error",
            html: `<h4 style="color:#CC2229; font-size: 20px; font-weight: bold;">Error!</h4>
            <p style="font-size: 16px;font-family:Poppins;">${responseJson1.title}</p>`,
            iconHtml: '<img src="assets/img/error.png" style="width: 55px; height: 55px;" />',
            width: 400,
            heightAuto: false,
          });
        } else {
          // Legal entity
          var allocate = [];
          var result = inputList.reduce(function (map, obj) {
            map[obj.businessunit] = obj.businessunitvalue;
            allocate.push(obj.businessunitvalue);
            return map;
          }, {});
          if (inputList.length === 0) {
            console.log("Zero Value");
          }
          const hasEmptyBusinessunit = inputList.some(
            (row) => row.businessunit === "" && row.businessunitvalue !== ""
          );
          if (hasEmptyBusinessunit) {
            setLoading(false);
            Swal.fire({
              icon: "error",
              html: `<h4 style="color:#CC2229; font-size: 20px; font-weight: bold;">Error!</h4>
              <p style="font-size: 16px;font-family:Poppins;">Please select legal entity</p>`,
              iconHtml: '<img src="assets/img/error.png" style="width: 55px; height: 55px;" />',
            });
            return false;
          }
          const sum = allocate.reduce((accumulator, currentValue) => {
            console.log(currentValue);
            return accumulator + parseFloat(currentValue);
          }, 0);
          console.log(3.75 + 2.25);
          console.log(sum);
          if (sum > 100) {
            setLoading(false);
            Swal.fire({
              icon: "error",
              html: `<h4 style="color:#CC2229; font-size: 20px; font-weight: bold;">Error!</h4>
              <p style="font-size: 16px;font-family:Poppins;">Total allocation to legal entities must not exceed 100%.</p>`,
              iconHtml: '<img src="assets/img/error.png" style="width: 55px; height: 55px;" />',
            });
            return false;
          }
          const uniqueBusinessUnits = {};
          const duplicates = {};
          inputList.forEach((item) => {
            const { businessunit } = item;
            if (!uniqueBusinessUnits[businessunit]) {
              uniqueBusinessUnits[businessunit] = true;
            } else {
              duplicates["count"] = (duplicates[businessunit] || 1) + 1;
            }
          });
          if (duplicates.count > 1) {
            setLoading(false);
            Swal.fire({
              icon: "error",
              html: `<h4 style="color:#CC2229; font-size: 20px; font-weight: bold;">Error!</h4>
              <p style="font-size: 16px;font-family:Poppins;">Multiple allocation to same legal entity not allowed</p>`,
              iconHtml: '<img src="assets/img/error.png" style="width: 55px; height: 55px;" />',
            });
            return false;
          }

          // Business Unit
          var allocate11 = [];
          var result11 = bunit.reduce(function (map, obj) {
            map[obj.bunit] = obj.bunitvalue;
            allocate11.push(obj.bunitvalue);
            return map;
          }, {});
          if (bunit.length === 0) {
            console.log("Zero Value");
          }
          const sum1 = allocate11.reduce((accumulator, currentValue) => {
            return accumulator + (parseFloat(currentValue) || 0);
          }, 0);

          if (sum1 > 100) {
            setLoading(false);
            Swal.fire({
              icon: "error",
              html: `<h4 style="color:#CC2229; font-size: 20px; font-weight: bold;">Error!</h4>
              <p style="font-size: 16px;font-family:Poppins;">Total allocation to business unit must not exceed 100%.</p>`,
              iconHtml: '<img src="assets/img/error.png" style="width: 55px; height: 55px;" />',
            });
            return false;
          }

          const uniqueBusinessUnits1 = {};
          const duplicates1 = {};
          bunit.forEach((item) => {
            const { bunit } = item;
            if (!uniqueBusinessUnits1[bunit]) {
              uniqueBusinessUnits1[bunit] = true;
            } else {
              duplicates1["count"] = (duplicates1[bunit] || 1) + 1;
            }
          });
          if (duplicates1.count > 1) {
            setLoading(false);
            Swal.fire({
              icon: "error",
              html: `<h4 style="color:#CC2229; font-size: 20px; font-weight: bold;">Error!</h4>
              <p style="font-size: 16px;font-family:Poppins;">Multiple allocation to same business unit not allowed</p>`,
              iconHtml: '<img src="assets/img/error.png" style="width: 55px; height: 55px;" />',
            });
            return false;
          }
          if (bunit.length > 0) {
            console.log(bunit);
          }
          if (sum > 100) {
            setLoading(false);
            Swal.fire({
              icon: "error",
              html: `<h4 style="color:#CC2229; font-size: 20px; font-weight: bold;">Error!</h4>
              <p style="font-size: 16px;font-family:Poppins;">LE Allocation is greater than 100%</p>`,
              iconHtml: '<img src="assets/img/error.png" style="width: 55px; height: 55px;" />',
            });
            return false;
          } else if (sum < 100) {
            setLoading(false);
            Swal.fire({
              icon: "error",
              html: `<h4 style="color:#CC2229; font-size: 20px; font-weight: bold;">Error!</h4>
              <p style="font-size: 16px;font-family:Poppins;">LE Allocation is less than 100%</p>`,
              iconHtml: '<img src="assets/img/error.png" style="width: 55px; height: 55px;" />',
            });
            return false;
          } else if (isNaN(sum)) {
            setLoading(false);
            Swal.fire({
              icon: "error",
              html: `<h4 style="color:#CC2229; font-size: 20px; font-weight: bold;">Error!</h4>
              <p style="font-size: 16px;font-family:Poppins;">LE Allocation is less than 100%</p>`,
              iconHtml: '<img src="assets/img/error.png" style="width: 55px; height: 55px;" />',
            });

            return false;
          } else {
            var result = inputList.reduce(function (map, obj) {
              map[obj.businessunit] = obj.businessunitvalue;
              return map;
            }, {});

            var result1 = bunit.reduce(function (map, obj) {
              map[obj.bunit] = obj.bunitvalue;
              return map;
            }, {});
            const isEmpty = Object.keys(result1).every((key) => key === "");
            if (isEmpty) {
              var result2 = {};
              console.log("Check empty");
            } else {
              // Business Unit
              const hasEmptyBunit = bunit.some(
                (row) => row.bunit === "" && row.bunitvalue !== ""
              );
              if (hasEmptyBunit) {
                setLoading(false);
                Swal.fire({
                  icon: "error",
                  html: `<h4 style="color:#CC2229; font-size: 20px; font-weight: bold;">Error!</h4>
                  <p style="font-size: 16px;font-family:Poppins;">Please select business unit</p>`,
                  iconHtml: '<img src="assets/img/error.png" style="width: 55px; height: 55px;" />',
                });
                return false;
              }
              var allocate1 = [];
              var result1 = bunit.reduce(function (map, obj) {
                map[obj.bunit] = obj.bunitvalue;
                allocate1.push(obj.bunitvalue);
                return map;
              }, {});
              const sum1 = allocate1.reduce((accumulator, currentValue) => {
                return accumulator + parseFloat(currentValue);
              }, 0);
              const uniqueBusinessUnits1 = {};
              const duplicates1 = {};
              bunit.forEach((item) => {
                const { bunit } = item;
                if (!uniqueBusinessUnits1[bunit]) {
                  uniqueBusinessUnits1[bunit] = true;
                } else {
                  duplicates1["count"] = (duplicates1[bunit] || 1) + 1;
                }
              });
              if (duplicates1.count > 1) {
                setLoading(false);
                Swal.fire({
                  icon: "error",
                  html: `<h4 style="color:#CC2229; font-size: 20px; font-weight: bold;">Error!</h4>
                  <p style="font-size: 16px;font-family:Poppins;">Multiple allocation to same business unit not allowed</p>`,
                  iconHtml: '<img src="assets/img/error.png" style="width: 55px; height: 55px;" />',
                });
                return false;
              }
              if (sum1 > 100) {
                setLoading(false);
                Swal.fire({
                  icon: "error",
                  html: `<h4 style="color:#CC2229; font-size: 20px; font-weight: bold;">Error!</h4>
                  <p style="font-size: 16px;font-family:Poppins;">Business unit Allocation is greater than 100%</p>`,
                  iconHtml: '<img src="assets/img/error.png" style="width: 55px; height: 55px;" />',
                });
                return false;
              }
              if (sum1 < 100) {
                setLoading(false);
                Swal.fire({
                  icon: "error",
                  html: `<h4 style="color:#CC2229; font-size: 20px; font-weight: bold;">Error!</h4>
                  <p style="font-size: 16px;font-family:Poppins;">Business unit Allocation is less than 100%</p>`,
                  iconHtml: '<img src="assets/img/error.png" style="width: 55px; height: 55px;" />',
                });
                return false;
              }
              if (isNaN(sum1)) {
                setLoading(false);
                Swal.fire({
                  icon: "error",
                  html: `<h4 style="color:#CC2229; font-size: 20px; font-weight: bold;">Error!</h4>
                  <p style="font-size: 16px;font-family:Poppins;">Business unit Allocation is less than 100%</p>`,
                  iconHtml: '<img src="assets/img/error.png" style="width: 55px; height: 55px;" />',
                });

                return false;
              }
              var result2 = bunit.reduce(function (map, obj) {
                map[obj.bunit] = obj.bunitvalue;
                return map;
              }, {});
              console.log("not empty");
            }

            //const countri = [country];
            let res = await fetch(`${process.env.REACT_APP_BASE_API_URL}create-sitelocation`, {
              method: "POST",
              headers: {
                "Content-type": "application/json; charset=UTF-8",
                username: username,
              },
              body: JSON.stringify({
                name: sitename,
                addressLine1: address1,
                addressLine2: "Address2",
                city: city,
                state: state,
                postalCode: postalcode,
                country: country,
                latitude: lat,
                siteType: sitetype,
                longitude: lng,
                parentAssociation: "",
                legalEntityMapping: result,
                businessUnitMapping: result2,
              }),
            });
            //let resJson = await res.json();
            if (res.status === 200) {
              const responseJson = await res.json();
              if (responseJson.success === false) {
                setLoading(false);
                console.log(responseJson);
                Swal.fire({
                  icon: "error",
                  html: `<h4 style="color:#CC2229; font-size: 20px; font-weight: bold;">Error!</h4>
            <p style="font-size: 16px;">${responseJson.data}</p>`,
                  iconHtml: '<img src="assets/img/error.png" style="width: 55px; height: 55px;" />',
                });
              } else if (responseJson.status === 400) {
                setLoading(false);
                Swal.fire({
                  icon: "error",
                  html: `<h4 style="color:#CC2229; font-size: 20px; font-weight: bold;">Error!</h4>
                       <p style="font-size: 16px;">${responseJson.title}</p>`,
                  iconHtml: '<img src="assets/img/error.png" style="width: 55px; height: 55px;" />',
                });
              } else {
                setName("");
                setAddress1("");
                setCountry("");
                setCity("");
                setPostalCode("");
                setState("");
                setLatitude("");
                setLongitude("");
                setSiteType("");
                setInputList([{ businessunit: "", businessunitvalue: "" }]);
                setBunit([{ bunit: "", bunitvalue: "" }]);
                setLoading(false);

                Swal.fire({
                  icon: "success",
                  html: '<h4 style="color:#407775;font-size: 20px;">Success!</h4><p style="font-size:16px;">New Site Location has been successfully created</p>',
                  iconHtml:
                    '<img src="assets/img/successicon.png" style="width: 55px; height: 55px;" />',
                  width: 400,
                  heightAuto: false,
                }).then(() => {
                  window.location.href = "/listsitelocations";
                });
              }
            } else {
              setLoading(false);
              Swal.fire({
                icon: "error",
                html: `<h4 style="color:#CC2229; font-size: 20px; font-weight: bold;">Error!</h4>
                <p style="font-size: 16px;">Error in creating site location</p>`,
                iconHtml: '<img src="assets/img/error.png" style="width: 55px; height: 55px;" />',
              });
            }
          }
        }
      } else {
        setLoading(false);
        Swal.fire({
          icon: "error",
          html: `<h4 style="color:#CC2229; font-size: 20px; font-weight: bold;">Error!</h4>
          <p style="font-size: 16px;">Something went wrong</p>`,
          iconHtml: '<img src="assets/img/error.png" style="width: 55px; height: 55px;" />',
        });
      }
    } catch (err) {
      setLoading(false);
      console.log(err);
    }
  };

  const [postalcodeError, setPostalCodeError] = useState("");
  const isNumeric = (value) => /^[0-9]*$/.test(value);
  // Helper function to check if the value is only numeric
  const isAlphanumericWithNumber = (value) => {
    const hasAlphabet = /[a-zA-Z]/.test(value);
    const hasNumeric = /[0-9]/.test(value);
    return hasAlphabet && hasNumeric;
  };

  // Function to validate the input based on the scenarios
  const validatePostalCode = (value) => {
    if (isNumeric(value) || isAlphanumericWithNumber(value)) {
      setPostalCodeError("");
      return true;
    } else {
      setPostalCodeError("Please enter a valid postal code.");
      return false;
    }
  };

  const handlePostalCodeChange = (e) => {
    const value = e.target.value;
    const alphanumeric = /^[a-zA-Z0-9]*$/; // Allow only alphanumeric characters
    if (
      alphanumeric.test(value) ||
      value === "" ||
      e.nativeEvent.inputType === "deleteContentBackward"
    ) {
      setPostalCode(value);
      validatePostalCode(value);
    }
  };

  const renderHeader = () => {
    const loginType = localStorage.getItem("loginType");
    if (loginType === "AAD") {
      return <AADHeader toggleSidebar={toggleSidebar} isSidebarOpen={isSidebarOpen} heading=""/>;
    }
    return <LoginHeader toggleSidebar={toggleSidebar} isSidebarOpen={isSidebarOpen} heading="" />;
  };
  return (
    <div id="wrapper">
      <div>
        {loading && (
          <Backdrop sx={{ color: "#fff", zIndex: (theme) => theme.zIndex.drawer + 1 }} open={true}>
            <CircularProgress color="inherit" />
          </Backdrop>
        )}
      </div>
      <div></div>
      {renderHeader()}
      <SideNavigation isSidebarOpen={isSidebarOpen} toggleSidebar={toggleSidebar} />
      <div
        id="page-content-wrapper"
        className={isSidebarOpen ? "page-content-wrapper-pd-0" : "page-wrapper"}
      >
        <div className="container formpd site-location-page">
          <div className="steps__containt-hader">
            <h3 className="title">Add Site Location</h3>
            <div role="presentation">
              <Breadcrumbs
                aria-label="breadcrumb"
                separator={<NavigateNextIcon fontSize="small" />}
              >
                <Links underline="hover" color="#707070" className="breadcrumbs-font">
                  Company
                </Links>
                <Link
                  to="/listsitelocations"
                  underline="hover"
                  color="#707070"
                  className="breadcrumbs-font"
                >
                  Site Locations
                </Link>

                <Typography color="inherit">Add Site Location</Typography>
              </Breadcrumbs>
            </div>
          </div>
          <div className="row">
            <div className="col-md-12">
              <div className="message">{message ? <p>{message}</p> : null}</div>
              <form onSubmit={handleSubmit} className="form-eco site-location-form">
                <div className="form-row site-split-row">
                  <div class="form-group col-md-6">
                    <label class="formlable" for="inputcompany">
                      Name <span className="mark-form">*</span>
                    </label>
                    <input
                      type="text"
                      value={sitename}
                      required
                      onChange={(e) => {
                        const v = e.target.value;
                        setName(v);
                        setNameError(/^[a-zA-Z0-9\-_\s]*$/.test(v) ? "" : "Special characters are not allowed.");
                      }}
                      className={`form-control ${nameError ? "is-invalid" : ""}`}
                      placeholder="Enter sitelocation name"
                    />
                    {nameError && <div className="invalid-feedback">{nameError}</div>}
                  </div>
                  <div class="form-group col-md-6">
                    <label class="formlable" for="inputState">
                      Site type <span className="mark-form">*</span>
                    </label>
                    <Dropdown
                      required
                      id="inputState"
                      className="form-control wd-100"
                      value={sitetype}
                      onChange={(e) => setSiteType(e.value)}
                      options={getsitetype.map((status) => ({ label: status, value: status }))}
                      placeholder="Select site type"
                    />
                  </div>
                </div>
                <div className="form-row site-split-row">
                  <div className="form-group col-md-6">
                    <label className="formlable" htmlFor="inputAddress">
                      Address <span className="mark-form">*</span>
                    </label>
                    <input
                      ref={autoCompleteRef}
                      type="text"
                      className="form-control"
                      required
                      id="inputAddress"
                      placeholder=""
                      value={address1}
                      onChange={(e) => setAddress1(e.target.value)}
                    />
                  </div>
                  <div className="form-group col-md-6">
                    <div className="form-row site-inner-row">
                      <div className="form-group col-md-6">
                        <label className="formlable" htmlFor="inputCountry">
                          Country <span className="mark-form">*</span>
                        </label>
                        <Dropdown
                          required
                          id="inputCountry"
                          className="form-control wd-100"
                          value={country}
                          onChange={(e) => setCountry(e.value)}
                          options={countries && countries.map((status) => ({ label: status, value: status }))}
                          placeholder="Select Country"
                          filter
                          filterPlaceholder="Search country"
                        />
                      </div>
                      <div className="form-group col-md-6">
                        <label className="formlable" htmlFor="inputStateName">
                          State <span className="mark-form">*</span>
                        </label>
                        <input
                          type="text"
                          className="form-control"
                          required
                          id="inputStateName"
                          placeholder=""
                          value={state}
                          onChange={(e) => {
                            const onlyAlphabets = /^[A-Za-z\s]+$/;
                            if (onlyAlphabets.test(e.target.value) || e.target.value === "") {
                              setState(e.target.value);
                            }
                          }}
                        />
                      </div>
                    </div>
                  </div>
                </div>
                <div className="form-row site-split-row">
                  <div className="form-group col-md-6">
                    <div className="form-row site-inner-row">
                      <div className="form-group col-md-6">
                        <label className="formlable" htmlFor="inputCityName">
                          City <span className="mark-form">*</span>
                        </label>
                        <input
                          type="text"
                          className="form-control"
                          required
                          id="inputCityName"
                          placeholder=""
                          value={city}
                          onChange={(e) => {
                            const onlyAlphabets = /^[A-Za-z\s]+$/;
                            if (onlyAlphabets.test(e.target.value) || e.target.value === "") {
                              setCity(e.target.value);
                            }
                          }}
                        />
                      </div>
                      <div className="form-group col-md-6">
                        <label className="formlable" htmlFor="inputPostalCode">
                          Zip/Postal Code <span className="mark-form">*</span>
                        </label>
                        <input
                          type="text"
                          className={`form-control ${postalcodeError ? "is-invalid" : ""}`}
                          required
                          id="inputPostalCode"
                          placeholder=""
                          value={postalcode}
                          onChange={handlePostalCodeChange}
                        />
                        {postalcodeError && <div className="invalid-feedback">{postalcodeError}</div>}
                      </div>
                    </div>
                  </div>
                  <div className="form-group col-md-6">
                    <div className="form-row site-inner-row">
                      <div className="form-group col-md-6">
                        <label className="formlable" htmlFor="inputLatitude">
                          Latitude <span className="mark-form">*</span>
                        </label>
                        <input
                          type="text"
                          className="form-control"
                          required
                          id="inputLatitude"
                          placeholder=""
                          value={lat}
                          onChange={(e) => {
                            const onlyNumericAndDecimal = /^-?[0-9]*\.?[0-9]*$/;
                            if (
                              onlyNumericAndDecimal.test(e.target.value) ||
                              e.target.value === "" ||
                              e.inputType === "deleteContentBackward"
                            ) {
                              setLatitude(e.target.value);
                            }
                          }}
                        />
                      </div>
                      <div className="form-group col-md-6">
                        <label className="formlable" htmlFor="inputLongitude">
                          Longitude <span className="mark-form">*</span>
                        </label>
                        <input
                          type="text"
                          className="form-control"
                          required
                          id="inputLongitude"
                          placeholder=""
                          value={lng}
                          onChange={(e) => {
                            const onlyNumericAndDecimal = /^-?[0-9]*\.?[0-9]*$/;
                            if (
                              onlyNumericAndDecimal.test(e.target.value) ||
                              e.target.value === "" ||
                              e.inputType === "deleteContentBackward"
                            ) {
                              setLongitude(e.target.value);
                            }
                          }}
                        />
                      </div>
                    </div>
                  </div>
                </div>
                <div className="App">
                  <div className="allocation-section-row legal-entity-row">
                  <div className="steps__containt-hader">
                    <h3 className="title-sl">
                      % Allocation to legal entities <span className="mark-form">*</span>
                    </h3>
                  </div>
                  {inputList.map((x, i) => {
                    return (
                      <div className="box">
                        <div className="form-row site-inner-row allocation-row">
                          <div className="form-group col-md-6 allocation-select-col">
                            <Dropdown
                              required
                              id={`legal-entity-${i}`}
                              className="form-control wd-100"
                              name="businessunit"
                              placeholder="Select legal entities"
                              value={x.businessunit || null}
                              onChange={(e) =>
                                handleInputChange(
                                  { target: { name: "businessunit", value: e.value } },
                                  i
                                )
                              }
                              options={
                                Array.isArray(activele)
                                  ? activele.map((status) => ({
                                      label: status.name,
                                      value: status.name,
                                      disabled: inputList.some(
                                        (selectedItem, selectedIndex) =>
                                          selectedIndex !== i &&
                                          selectedItem.businessunit === status.name
                                      ),
                                    }))
                                  : []
                              }
                            />
                          </div>
                          <div className="form-group col-md-3 allocation-value-col">
                            <input
                              type="text"
                              inputMode="numeric"
                              className="form-control"
                              name="businessunitvalue"
                              placeholder="Ex.60%..."
                              value={x.businessunitvalue}
                              onChange={(e) => handleInputChange(e, i)}
                            />
                          </div>
                          <div className="form-group col-md-3 allocation-action-col">
                            <div className="btn-box">
                              {inputList.length !== 1 && (
                                <button
                                  type="button"
                                  className="mr10 btn btn-danger"
                                  onClick={() => handleRemoveClick(i)}
                                >
                                  Remove
                                </button>
                              )}
                              {inputList.length - 1 === i && (
                                <button
                                  type="button"
                                  id="addMore"
                                  onClick={handleAddClick}
                                  className="btn btn-primary"
                                  disabled={isButtonDisabled}
                                >
                                  Add more
                                </button>
                              )}
                            </div>
                          </div>
                        </div>
                      </div>
                    );
                  })}
                  <div className="box">
                    <div className="form-row">
                      <div className="form-group col-md-12">
                        <AllocationBanner
                          currentTotal={legalEntityTotal}
                          label="legal entity"
                          show={hasAnyLegalAllocation}
                        />
                      </div>
                    </div>
                  </div>
                  </div>

                  <div className="allocation-section-row business-unit-row">
                  <div className="steps__containt-hader">
                    <h3 className="title-sl">% Allocation to business unit</h3>
                  </div>
                  {bunit.map((x, i) => {
                    return (
                      <div className="box">
                        <div className="form-row site-inner-row allocation-row">
                          <div className="form-group col-md-6 allocation-select-col">
                            <Dropdown
                              id={`business-unit-${i}`}
                              className="form-control wd-100"
                              name="bunit"
                              placeholder="Select business unit"
                              value={x.bunit || null}
                              onChange={(e) =>
                                handleInputChange1(
                                  { target: { name: "bunit", value: e.value } },
                                  i
                                )
                              }
                              options={
                                Array.isArray(activebu)
                                  ? activebu.map((status) => ({
                                      label: status.name,
                                      value: status.name,
                                      disabled: bunit.some(
                                        (selectedItem, selectedIndex) =>
                                          selectedIndex !== i && selectedItem.bunit === status.name
                                      ),
                                    }))
                                  : []
                              }
                            />
                          </div>
                          <div className="form-group col-md-3 allocation-value-col">
                            <input
                              type="text"
                              inputMode="numeric"
                              className="form-control"
                              name="bunitvalue"
                              placeholder="Ex.60%..."
                              value={x.bunitvalue}
                              onChange={(e) => handleInputChange1(e, i)}
                            />
                          </div>
                          <div className="form-group col-md-3 allocation-action-col">
                            <div className="btn-box">
                              {bunit.length > 1 && (
                                <button
                                  type="button"
                                  className="mr10 btn btn-danger"
                                  onClick={() => handleRemoveClick1(i)}
                                >
                                  Remove
                                </button>
                              )}
                              {bunit.length - 1 === i && (
                                <button
                                  type="button"
                                  id="addMore"
                                  onClick={handleAddClick1}
                                  className="btn btn-primary"
                                  disabled={isButtonDisabled1}
                                >
                                  Add more
                                </button>
                              )}
                            </div>
                          </div>
                        </div>
                      </div>
                    );
                  })}
                  <div className="box">
                    <div className="form-row">
                      <div className="form-group col-md-12">
                        <AllocationBanner
                          currentTotal={businessUnitTotal}
                          label="business unit"
                          show={hasAnyBusinessUnitAllocation}
                        />
                      </div>
                    </div>
                  </div>
                  </div>
                </div>
                <div className="site-location-actions">
                  <Button
                    type="submit"
                    disabled={
                      loading ||
                      !!nameError ||
                      legalEntityAllocationExceeds100 ||
                      businessUnitAllocationExceeds100 ||
                      legalEntityAllocationBelow100 ||
                      businessUnitAllocationBelow100 ||
                      legalEntityMissingSelection ||
                      businessUnitMissingSelection
                    }
                    className="next-button"
                    variant="contained"
                    size="medium"
                    sx={{
                      color: "#fff",
                      backgroundColor: "#407775",
                      width: "120px",
                      height: "41px",
                      borderRadius: "10px",
                    }}
                  >
                    Submit
                  </Button>
                  <Button
                    href="listsitelocations"
                    variant="outlined"
                    className="outline-btn"
                    size="medium"
                    sx={{
                      color: "#000",
                      marginLeft: "15px",
                      width: "120px",
                      height: "41px",
                      borderRadius: "10px",
                    }}
                  >
                    Cancel
                  </Button>
                </div>
              </form>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}
